<template>
    <div name="navigation" class="navigation">
        <div class="nav-button" @click="navivation(0)">
            <svg xmlns="http://www.w3.org/2000/svg" width="5vw" height="5vw" viewBox="0 0 19 20" fill="#EFF6FC">
                <path d="M0 7.24981C0 6.93171 0.151341 6.63259 0.407622 6.44415L8.90762 0.194348C9.26004 -0.0647723 9.73996 -0.0647725 10.0924 0.194348L18.5924 6.44415C18.8487 6.63259 19 6.93171 19 7.24981V18.7588C19 19.3111 18.5523 19.7588 18 19.7588H13.0333C12.481 19.7588 12.0333 19.3111 12.0333 18.7588V14.4304C12.0333 13.8781 11.5856 13.4304 11.0333 13.4304H7.96667C7.41438 13.4304 6.96667 13.8781 6.96667 14.4304V18.7588C6.96667 19.3111 6.51895 19.7588 5.96667 19.7588H1C0.447716 19.7588 0 19.3111 0 18.7588V7.24981Z" fill="#A3AAB6"/>
            </svg>
            <span>홈</span>
        </div>        
        
        <div class="nav-button" @click="navivation(1)">
            <svg xmlns="http://www.w3.org/2000/svg" width="5vw" height="5vw" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.63523 1.9C5.45483 1.9 2.88235 4.50892 2.88235 7.71999C2.88235 10.9311 5.45483 13.54 8.63523 13.54C9.92477 13.54 11.1144 13.1111 12.0731 12.387C12.0747 12.3858 12.0763 12.3845 12.078 12.3833L12.0825 12.3799C13.4829 11.3177 14.3881 9.6248 14.3881 7.71999C14.3881 4.50892 11.8156 1.9 8.63523 1.9ZM12.9489 12.8262C14.3695 11.5942 15.2705 9.76451 15.2705 7.71999C15.2705 4.00542 12.2966 1 8.63523 1C4.97387 1 2 4.00542 2 7.71999C2 11.4346 4.97387 14.44 8.63523 14.44C9.96387 14.44 11.202 14.0442 12.2403 13.3624L16.2044 18.8179C16.3494 19.0176 16.6257 19.0595 16.8215 18.9115C17.0172 18.7635 17.0583 18.4817 16.9132 18.282L12.9489 12.8262Z" fill="#A3AAB6" stroke="#A3AAB6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>병원검색</span>
        </div>
        <div class="nav-button" @click="navivation(2)">
            <svg xmlns="http://www.w3.org/2000/svg" width="5vw" height="5vw" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_1144_1135)">
                <path d="M13.7026 11.0283C13.8283 11.2949 14.0858 11.4628 14.3667 11.4629H18.6099C15.9087 15.6258 10.13 19.968 10.0874 20C10.0874 20 4.27507 15.6413 1.56396 11.4629H4.43896C4.68216 11.4628 4.90827 11.337 5.04639 11.1279L6.28271 9.25391L8.3999 12.7246C8.68995 13.2 9.34403 13.2046 9.64014 12.7334L12.4204 8.30859L13.7026 11.0283ZM14.6509 2C17.6929 2.00033 19.9741 5.1977 19.9741 7.83105C19.9741 8.65813 19.6753 9.56483 19.1821 10.499C19.1045 10.4454 19.012 10.4141 18.9126 10.4141H14.519L13.1147 7.43457C12.8756 6.92833 12.2372 6.85562 11.8979 7.2627L11.8345 7.35059L9.0249 11.8193L6.91357 8.35645L6.85596 8.27441C6.56905 7.91411 6.0428 7.90405 5.74365 8.25293L5.68311 8.33301L4.31006 10.4141H0.946777C0.480207 9.50998 0.199723 8.63294 0.199707 7.83105C0.199707 5.19756 2.73519 2 5.52393 2C7.55205 2.00018 10.0874 3.77441 10.0874 3.77441C10.1242 3.75104 12.8881 2 14.6509 2Z" fill="#A3AAB6"/>
            </g>
            <defs>
                <clipPath id="clip0_1144_1135">
                <rect width="20" height="20" fill="white"/>
                </clipPath>
            </defs>
            </svg>
            <span>내 건강</span>
        </div>
        <div class="nav-button" @click="navivation(3)">
            <svg xmlns="http://www.w3.org/2000/svg" width="5vw" height="5vw" viewBox="0 0 19 20" fill="none">
                <path d="M15 0C15.5523 0 16 0.447715 16 1V2H18C18.5523 2 19 2.44772 19 3V19C19 19.5523 18.5523 20 18 20H1C0.447715 20 4.02662e-09 19.5523 0 19V3C2.57704e-07 2.44772 0.447715 2 1 2H3V1C3 0.447715 3.44772 2.0133e-08 4 0H15ZM4.65039 12.7002C4.29141 12.7002 4 12.9916 4 13.3506C4.00021 13.7094 4.29154 14 4.65039 14H14.3496C14.7085 14 14.9998 13.7094 15 13.3506C15 12.9916 14.7086 12.7002 14.3496 12.7002H4.65039ZM4.65039 7.7002C4.29141 7.7002 4 7.9916 4 8.35059C4.00021 8.70939 4.29154 9 4.65039 9H14.3496C14.7085 9 14.9998 8.70939 15 8.35059C15 7.9916 14.7086 7.7002 14.3496 7.7002H4.65039Z" fill="#A3AAB6"/>
            </svg>
            <span>진료내역</span>
        </div>
        
        <div class="nav-button" @click="navivation(4)">
            <svg xmlns="http://www.w3.org/2000/svg" width="5vw" height="5vw" viewBox="0 0 19 20" fill="none">
                <rect width="19" height="20" rx="1" fill="#A3AAB6"/>
                <path d="M9.5 5C11.8669 5 13.7861 6.9192 13.7861 9.28613C13.786 10.7884 13.0118 12.1089 11.8418 12.874C14.8369 13.8577 17 16.6758 17 20H2C2 16.6761 4.16254 13.858 7.15723 12.874C5.98764 12.1089 5.21401 10.7881 5.21387 9.28613C5.21387 6.9192 7.13307 5 9.5 5Z" fill="white"/>
            </svg>
            <span>마이페이지</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'navigation',
    methods: {
        navivation: function(nav)
        {
            this.$emit('onClick', nav);
        }   
    }
}
</script>

<style scoped>
    .navigation {
        position: fixed;
        width: calc(100% - 8.6vw);
        aspect-ratio: 375/60;
        background: #FFF;
        border-radius: 64px 64px 0 0;
        z-index: 999;
        bottom: calc(100vw * 60 / 375);
        stroke-width: 1px;
        stroke: var(--point-color2, #EFF6FC);
        backdrop-filter: blur(5px);
        border: 1px solid #EFF6FC;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 2vh 10vw;
    }
    .nav-button{
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 2.2vw;
        gap: 0.6vh;
        color: var(--theme-main);
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Navigation.vue